import * as React from "react"

function IconSection(props) {
  return (
    <svg
      width={16}
      height={16}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path d="M3 3v3h10V3M13 13v-3H3v3" stroke="#35383B" />
    </svg>
  )
}

export default IconSection
